import authority from '@/services/AuthService'
import type { Preferences, PreferencesAPIDetail, TrainingLevel, User, UserAPIListItem } from '#/User'
import type { DRFPaginationQueries, PaginationAPIList } from '#/index'
import { getQueries } from '@/services/ServiceUtils.ts'

export const getUser = async (): Promise<User> => {
  return (await authority.get<User>('/api/profile/')).data
}

export interface MembersAPIOptions extends DRFPaginationQueries {
  for_collaboration?: string
  for_story?: string
  for_team?: string
  search?: string
}

export const getMembers = async (options: MembersAPIOptions): Promise<PaginationAPIList<UserAPIListItem>> => {
  return (await authority.get<PaginationAPIList<UserAPIListItem>>(`/api/members/${getQueries(options)}`)).data
}

export const patchProfile = async (profile: Partial<User>): Promise<User> => {
  return (await authority.patch<User>('/api/profile/', profile)).data
}

export const refreshProfile = async (): Promise<User> => {
  return (await authority.patch<User>('/api/profile/refresh/')).data
}

export const getUserPreferences = async (): Promise<Preferences> => {
  return (await authority.get<PreferencesAPIDetail>('/api/profile/preferences/')).data?.preferences
}

export const patchUserPreferences = async (preferences: Partial<Preferences>): Promise<Preferences> => {
  return (
    await authority.patch<PreferencesAPIDetail>('/api/profile/preferences/', {
      preferences,
    })
  ).data?.preferences
}

export const getTrainingLevels = async (): Promise<TrainingLevel[]> => {
  return (await authority.get('/api/training-levels/')).data
}
